/**
 * Customize Card Updater
 * Dynamically updates the customize card when variant options change
 */

class CustomizeCardUpdater {
  constructor() {
    this.card = document.querySelector('[data-customize-card]');
    this.variantSelectors = document.querySelectorAll('[data-product-option]');

    if (!this.card || this.variantSelectors.length === 0) return;

    this.init();
  }

  init() {
    // Listen to changes in variant option selectors
    this.variantSelectors.forEach((optionElement) => {
      // Handle select dropdowns
      const selectElement = optionElement.querySelector('select');
      if (selectElement) {
        selectElement.addEventListener('change', (e) => {
          this.updateCardValue(selectElement);
        });
      }

      // Handle color swatches/buttons
      const buttons = optionElement.querySelectorAll('[data-button]');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          // Wait a bit for the DOM to update with selected values
          setTimeout(() => {
            this.updateAllCardValues();
          }, 50);
        });
      });

      // Handle chip buttons
      const chips = optionElement.querySelectorAll('.product__chip');
      chips.forEach(chip => {
        chip.addEventListener('click', () => {
          setTimeout(() => {
            this.updateAllCardValues();
          }, 50);
        });
      });
    });

    // Listen to variant changes via custom event (if the theme uses it)
    document.addEventListener('variant:change', () => {
      this.updateAllCardValues();
    });
  }

  /**
   * Update a specific card value based on select element change
   */
  updateCardValue(selectElement) {
    const optionIndex = selectElement.getAttribute('data-index');
    if (!optionIndex) return;

    const selectedValue = selectElement.value;
    const optionNumber = optionIndex.replace('option', '');

    // Find the corresponding card value element
    const valueElement = this.card.querySelector(`[data-customize-value="${optionNumber}"]`);
    if (valueElement) {
      valueElement.textContent = selectedValue;
    }
  }

  /**
   * Update all card values by reading from the DOM
   */
  updateAllCardValues() {
    // Find all selected value spans in the product options
    const selectedValueElements = document.querySelectorAll('[data-selected-value-for-option]');

    selectedValueElements.forEach((valueElement) => {
      const optionName = valueElement.getAttribute('data-option-name');
      if (!optionName) return;

      const optionNumber = optionName.replace('option', '');
      const selectedValue = valueElement.textContent.trim();

      // Update corresponding card value
      const cardValueElement = this.card.querySelector(`[data-customize-value="${optionNumber}"]`);
      if (cardValueElement && selectedValue) {
        cardValueElement.textContent = selectedValue;
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomizeCardUpdater();
  });
} else {
  new CustomizeCardUpdater();
}
